import { render, staticRenderFns } from "./PrivacyPolicy_mobile.vue?vue&type=template&id=736836d6&scoped=true&"
import script from "./PrivacyPolicy_mobile.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicy_mobile.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicy_mobile.vue?vue&type=style&index=0&id=736836d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736836d6",
  null
  
)

export default component.exports